import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-ricette',
  templateUrl: './ricette.component.html',
  styleUrls: ['./ricette.component.css']
})
export class RicetteComponent implements OnInit {
  listFields:any[]=[];
  pageTitle:string='';
  listParams:any={};
  struttureList:any[]=[];
  newRecordUrl:string='';
  editRecordUrl:string='';
  deleteRecordUrl:string='';
  isLoading=true;

  struttura_id:number=0;
 

  constructor(
      private apiService: ApiService,
      private globalService: GlobalService,
  ) { }

  ngOnInit(): void {
    
    this.pageTitle="";
    this.newRecordUrl='dashboard/gestionemensa/ricette/ricette-edit/new/';
    this.editRecordUrl='dashboard/gestionemensa/ricette/ricette-edit/update/';
    this.deleteRecordUrl='mensa/mensa_ricetta_delete';
    
        
    this.listFields=
    [
      {
        field:'id',
        type:'edit',
        pSortableColumnDisabled:true,
        style:'width:50px;text-align:center;'
      },
      {
        field:'nome',
        type:'field',
        header:'Nome',
      },
      {
        field:'tipo',
        type:'field',
        header:'Piatto',
      },
      {
        field:'id',
        type:'delete',
        header:'Elimina ricetta',
      },
      
    ];
  }
  
  
  

}
